// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3GgdH","title":"Header_title__iFPTG","left":"Header_left__1ConH","clinicName":"Header_clinicName__1R-md"};